import React from 'react';
import { useVoting } from '../../contexts/VotingContext';
import { Countdown } from '../common/Countdown';

export const VoteHeader = ({ countdownDateUtc, isPaused, isShowBorder }) => {
    const { ballot } = useVoting();

    return (
        <div className={`${isShowBorder ? "pb-4 border-gray-300 border-b mb-4" : ""}`}>
            <div className="flex justify-between items-center">
                {ballot?.orgLogo &&
                    <div className="flex-none hidden md:block">
                        <img src={ballot.orgLogo} className="mx-auto h-16 max-w-[200px] object-contain" alt={ballot.orgName} />
                    </div>
                }
                <div className={`flex-grow ${ballot?.orgLogo ? " md:pl-4" : ""}`}>
                    <span className="text-3xl block pb-2">{ballot.orgName}</span>
                    <span className="text-xl">{ballot.name}</span>
                </div>
                {countdownDateUtc &&
                    <div className="flex-none">
                        <Countdown
                            className="rounded-lg text-white py-2 px-4 font-bold uppercase bg-blue-700 text-xl"
                            targetDateUtc={countdownDateUtc}
                            isPaused={isPaused} />
                    </div>
                }
            </div>
        </div>
    );
}